export enum PaymentPlatform {
    PAYPAL = 'PAYPAL',
    CASH_APP = 'CASH_APP',
    ZELLE = 'ZELLE',
}

export interface PaymentRequest {
    paymentPlatform: PaymentPlatform,
    phoneNumber: string,
    amount: number,
}